/**
 * Component: Size guide
 * ------------------------------------------------------------------------------
 * Function to open the size guide of a product.
 *
 * @namespace sizeGuide
 */
import {on} from '../helpers/utils';
import Carousel from './carousel';
import Modal from './modal';


/**
 * DOM selectors.
 */
const selectors = {
  sizeGuideButton: '[js-size-guide="button"]',
  carouselContainer: '[js-size-guide="carousel"]',
  carouselCell: '[js-size-guide="slide"]',
};

/**
 * Create a new size guide object.
 */
export default () => {

  const namespace = 'size-guide';
  let carousel = {};

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    sizeGuideButton: [...document.querySelectorAll(selectors.sizeGuideButton)],
  };

  /**
   * Global instances.
   */
  const modal = new Modal({
    id: namespace,
  });

  /**
   * Initialise component.
   */
  function init() {
    if (!nodeSelectors.sizeGuideButton.length) {
      return;
    }

    modal.init();
    setEventListeners();
  }

  /**
   * Initialise carousel.
   */
  function initCarousel() {
    carousel = Carousel(selectors.carouselContainer, {
      cellSelector: selectors.carouselCell,
      pageDots: true,
      prevNextButtons: true,
    });

    carousel.init();
  }

  /**
   * Set trigger listeners.
   */
  function setEventListeners() {
    nodeSelectors.sizeGuideButton.forEach((item) => {
      on('click', item, () => {
        modal.show(namespace);
        initCarousel();
      });
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
